import L from 'leaflet';

export const icon = L.icon({
    iconUrl:       'images/marker-icon.png',
	iconRetinaUrl: 'images/marker-icon-2x.png',
	shadowUrl:     'images/marker-shadow.png',
	iconSize:    [25, 41],
	iconAnchor:  [12, 41],
	popupAnchor: [1, -34],
	tooltipAnchor: [0, 0],
	shadowSize:  [41, 41]
});

export const dot_orange = L.icon({
  iconUrl: 'images/dot_orange.png',
  iconSize: [16, 16],
  iconAnchor: [8, 8]
});
